import { adapter } from "@hg/adapt-sdk"

adapter.init({
    extraParams: [
        {
            key: "invite_code",
            convertTo: "string",
        },
        {
            key: "page",
            convertTo: "string",
        },
    ],
})

export const getInviteCode = () => {
    return String(adapter.getExtraParams().invite_code || "")
}

export const getPage = () => {
    return String(adapter.getExtraParams().page || "")
}

export { adapter }

export const source = {
    source_from: adapter.source.from || "",
    share_type: adapter.share.type || "",
    share_by: (() => {
        const share_by = adapter.share.by || ""
        if (!share_by) {
            return ""
        }

        try {
            return window.atob(share_by)
        } catch (e) {
            return ""
        }
    })(),
}

const emptyFn = () => {}

export const mockSdk = {
    ETL: {
        event: emptyFn,
        instance: { setPageProperties: emptyFn },
    },
    Share: { setShareInfo: emptyFn },
    socialShare: {
        setGlobalConfig: emptyFn,
        getAvailableChannels: async () => [] as { key: string }[],
        shareSiteTo: async () => true,
        utils: {
            generateQRCode: async () =>
                "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==",
        },
    },
}

export const sdkReady = async (cb?: (sdk: typeof mockSdk) => void) => {
    if (cb) cb(mockSdk)
    return mockSdk
}

export async function collect(
    event: string,
    properties: Record<string, unknown> = {},
) {
    return
}

export function getShareImgUrl() {
    return "https://web-public.hycdn.cn/biz_toolset/upload/260203/ntykkqG81IrKy89z.png"
}
